import request from '@/utils/request';
// 获取所有的字段包信息
export function getAllFieldPackage() {
  return request('/decision/field/field-package/all', {
    method: 'GET',
  });
}
// 获取所有的字段包信息
export function getFieldPackageDetails(values) {
  return request('/decision/field', {
    method: 'GET',
    params: values,
  });
}
// 出参配置
export function getConstruct() {
  return request('/decision/diagram/construct/node-block', {
    method: 'GET',
  });
}
// 出参配置输出项
export function getConstructDetails(values) {
  return request('/decision/diagram/node-input-item/node-block', {
    method: 'GET',
    params: values,
  });
}
// 新增字段包
export function getAllPackages() {
  return request('/decision/field/packages', {
    method: 'GET',
  });
}
